// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Card that exposes a button to open the fulfillment order audit log in a
 * drawer. The audit events load lazily when the drawer is opened.
 */
import { HistoryOutlined } from '@/constants/hardfin-standard-icons';
import { FulfillmentAuditDrawer } from '@/fulfillment/components/fulfillment-audit-drawer';
import { useDisclosure } from '@/hooks/use-disclosure';
import { Button, Paper } from '@mui/material';

interface Props {
  fulfillmentKey: string;
}

export function FulfillmentAuditCard(props: Props) {
  const drawer = useDisclosure();

  return (
    <Paper variant="outlined" sx={{ padding: 2 }}>
      <Button
        fullWidth
        size="small"
        startIcon={<HistoryOutlined />}
        onClick={drawer.open}
      >
        View audit log
      </Button>
      <FulfillmentAuditDrawer
        fulfillmentKey={props.fulfillmentKey}
        disclosure={drawer}
      />
    </Paper>
  );
}
